var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "OI_4L_main",
    d: "M113.8 113.8H83.9c-2.2 0-4-1.8-4-4v-4c0-2.2 1.8-4 4-4h29.9c2.2 0 4 1.8 4 4v4c0 2.2-1.8 4-4 4zM113.8 95.6H83.9c-2.2 0-4-1.8-4-4v-4c0-2.2 1.8-4 4-4h29.9c2.2 0 4 1.8 4 4v4c0 2.3-1.8 4-4 4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 56.6,
    cy: 56.8,
    r: 6.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 39.1,
    cy: 99.1,
    r: 6.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 57.2,
    cy: 142.2,
    r: 6.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 98.7,
    cy: 159.3,
    r: 6.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 141.8,
    cy: 141.6,
    r: 6.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 159.3,
    cy: 98.5,
    r: 6.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 141.2,
    cy: 56.2,
    r: 6.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 98.5,
    cy: 39.1,
    r: 6.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 98.8,
    cy: 56.7,
    r: 1.1
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 98.8,
    cy: 66.1,
    r: 1.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 98.8,
    cy: 131.5,
    r: 1.1
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 98.8,
    cy: 140.9,
    r: 1.1
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 131.5,
    cy: 98.8,
    r: 1.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 140.9,
    cy: 98.8,
    r: 1.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 128.6,
    cy: 68.5,
    r: 1.1
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 121.9,
    cy: 75.1,
    r: 1.1
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 128.6,
    cy: 68.5,
    r: 1.1
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 128.6,
    cy: 128.5,
    r: 1.1
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 121.9,
    cy: 121.8,
    r: 1.1
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 65.8,
    cy: 98.8,
    r: 1.1
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 56.4,
    cy: 98.8,
    r: 1.1
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 68.8,
    cy: 68.5,
    r: 1.1
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 75.4,
    cy: 75.1,
    r: 1.1
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 68.8,
    cy: 128.5,
    r: 1.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "OI_4L_main",
    cx: 75.4,
    cy: 121.8,
    r: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.15c575178c2fb4c9c954207b12f140f7.svg";
export { ForwardRef as ReactComponent };